class DigiClubModal extends HTMLElement {
  constructor() {
    super();

    this.selectedItems = [];
    this.currentPlan = '';
    this.products = [];
    this.giftThresholds = [];
    this.currentStep = 1;

    this.openSummaryOnStepTwo = false;
    
  }

  connectedCallback() {
    console.log("[Modal] connectedCallback");
    this.overlay = this.querySelector('.digi-club-modal-overlay');
    this.closeBtn = this.querySelector('.digi-club-modal-close');
    this.checkoutBtn = this.querySelector('[data-checkout-btn]');
    this.alertModal = this.querySelector('[data-alert-modal]');
    this.alertBtn = this.querySelector('[data-alert-btn]');
    this.productsGrid = this.querySelector('[data-products-grid]');
    this.tabs = this.querySelectorAll('[data-plan]');
    this.progressFill = this.querySelector('[data-progress-fill]');
    this.summaryPanel = this.querySelector('.digi-club-summary-panel');
    this.planConfig = this.dataset.planConfig;
    this.enableSubscriptionFlyer =
      this.dataset.enableSubscriptionFlyer === 'true';
    this.planOptions = this.querySelectorAll('.digi-club-plan-option');
    this.nextStepBtn = this.querySelector('.digi-club-btn-next-step');

    this.setupEventListeners();
    console.log("[Modal] chamando setupGlobalTriggers()");
    this.setupGlobalTriggers();
    this.setupStepOne();
    this.setupTabs();
    this.setupProductCards(); 
    this.setupSummaryToggle();
    this.setupSummaryCloseOutside();
    this.setupTerms();
    this.updateCheckoutState();

    // MODO DEV — sempre aberto
    if (window.location.search.includes('modal=dev')) {
      this.open();
    }
  }

  setupEventListeners() {
    if (this.overlay) {
    this.overlay.addEventListener('click', () => this.close());
    }

    if (this.closeBtn) {
    this.closeBtn.addEventListener('click', () => this.close());
    }

    this.checkoutBtn?.addEventListener('click', () => this.checkout());
  }

  getPresetProductsFromTrigger(trigger) {
    if (!trigger) {
      return [];
    }

    const rawProducts =
      trigger.dataset.products;

    if (rawProducts) {
      try {
        const parsedProducts =
          JSON.parse(rawProducts);

        if (Array.isArray(parsedProducts)) {
          return parsedProducts;
        }
      } catch (error) {
        console.error(
          "[Digi Club Modal] Produtos pré-selecionados inválidos.",
          error
        );
      }
    }

    const productId =
      trigger.dataset.productId;

    if (!productId) {
      return [];
    }

    const quantity =
      Math.max(
        1,
        Number(
          trigger.dataset.quantity
        ) || 1
      );

    return [
      {
        productId,
        quantity
      }
    ];
  }

  applyProductPreset(products = []) {
    if (!Array.isArray(products)) {
      return;
    }

    const cards = Array.from(
      this.querySelectorAll(
        ".digi-club-product-card"
      )
    );

    products.forEach((presetItem) => {
      const presetProductId =
        String(
          presetItem.productId ||
          presetItem.id ||
          ""
        );

      if (!presetProductId) {
        return;
      }

      const quantity =
        Math.max(
          1,
          Number(
            presetItem.quantity
          ) || 1
        );

      const card =
        cards.find((currentCard) =>
          String(
            currentCard.dataset.productId
          ) === presetProductId
        );

  
      if (!card) {
        console.warn(
          "[Digi Club Modal] Produto não encontrado no modal:",
          presetProductId
        );

        return;
      }

      const productName =
        card.querySelector(
          ".digi-club-product-name"
        )?.textContent?.trim() || "";

      const productImage =
        card.querySelector("img")?.src || "";

      const priceText =
        card.querySelector(
          ".price-final"
        )?.textContent || "";

      const price =
        Number(
          priceText
            .replace(/[^\d,]/g, "")
            .replace(",", ".")
        ) || 0;

      const compareText =
        card.querySelector(
          ".price-compare"
        )?.textContent || "";

      const comparePrice =
        compareText
          ? Number(
              compareText
                .replace(/[^\d,]/g, "")
                .replace(",", ".")
            ) || price
          : price;

      const existingItem =
        this.selectedItems.find(
          (item) =>
            String(item.id) ===
            presetProductId
        );

      if (existingItem) {
        existingItem.quantity =
          quantity;
      } else {
        this.selectedItems.push({
          id: card.dataset.productId,
          name: productName,
          image: productImage,
          price,
          comparePrice,
          quantity
        });
      }

      card.classList.add(
        "selected"
      );

      const quantitySelector =
        card.querySelector(
          ".digi-club-quantity-selector"
        );

      const quantityDisplay =
        card.querySelector(
          ".digi-club-qty-display"
        );

      quantitySelector?.classList.remove(
        "is-hidden"
      );

      if (quantityDisplay) {
        quantityDisplay.textContent =
          quantity;
      }
    });

this.hasPreset = true;

this.renderSummaryItems();
  }

    setupGlobalTriggers() {
console.log("[Modal] setupGlobalTriggers()");
      document.addEventListener('click', (event) => {
        console.log(
  "[Modal] Clique detectado",
  event.target
);

const trigger = event.target.closest(
  [
    "[data-digi-club-modal-trigger]",
    "[data-open-subscription]"
  ].join(",")
);

if (!trigger) return;

        event.preventDefault();

const plan =
  trigger.dataset.subscriptionPlan ||
  trigger.dataset.planType ||
  "";

const presetProducts =
  this.getPresetProductsFromTrigger(
    trigger
  );

this.open();

if (presetProducts.length > 0) {
  this.applyProductPreset(
    presetProducts
  );
}

if (plan) {
  this.selectPlan(plan);
}

        if (
          window.location.hash ===
          '#digi-club-modal'
        ) {
          window.history.replaceState(
            {},
            '',
            window.location.pathname +
              window.location.search
          );
        }
      });

      document.addEventListener(
        'openSubscriptionModal',
        (event) => {
          this.open();

          const plan =
            event.detail?.planType;

          if (plan) {
            this.selectPlan(plan);
          }
        }
      );

      document.addEventListener(
        'openSubscriptionAlert',
        (event) => {
          this.openAlertModal(
            event.detail || {}
          );
        }
      );

      if (
        window.location.hash ===
        '#digi-club-modal'
      ) {
        window.requestAnimationFrame(() => {
          this.open();

          window.history.replaceState(
            {},
            '',
            window.location.pathname +
              window.location.search
          );
        });
      }
    }

  setupStepOne() {
    this.planOptions.forEach(option => {
      option.addEventListener('click', () => {

        this.planOptions.forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');

        this.currentPlan = option.dataset.plan;
        this.updateCategoryBadges();

        if (this.nextStepBtn) {
          this.nextStepBtn.disabled = false;
        }
      });
    });

    this.nextStepBtn?.addEventListener('click', () => {
      this.goToStep(2);
    });
  }

  setupTabs() {
    const tabs = this.querySelectorAll('.digi-club-tab');
    const contents = this.querySelectorAll('[data-tab-content]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {

        const target = tab.dataset.tab;

        // ativa aba
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        // troca conteúdo
        contents.forEach(content => {
          content.style.display =
            content.dataset.tabContent === target ? 'grid' : 'none';
        });

      });
    });
  }

  setupProductCards() {
    const container = this.querySelector('.digi-club-products');

    if (!container) return;

    // CLICK NOS CARDS
    container.addEventListener('click', (e) => {
      const card = e.target.closest('.digi-club-product-card');
      if (!card) return;

      // evita conflito com +/-
      if (e.target.closest('.digi-club-qty-btn')) return;

      const qtySelector = card.querySelector('.digi-club-quantity-selector');
      const display = card.querySelector('.digi-club-qty-display');

      const existing = this.selectedItems.find(
        item => item.id === card.dataset.productId
      );

      if (!existing) {
        // PRIMEIRA VEZ → adiciona item
        card.classList.add('selected');
        qtySelector?.classList.remove('is-hidden');

        const productName = card.querySelector('.digi-club-product-name')?.textContent;
        const productImage = card.querySelector('img')?.src;

        const priceText = card.querySelector('.price-final')?.textContent || '';
        const price = Number(priceText.replace(/[^\d,]/g, '').replace(',', '.'));

        const compareText = card.querySelector('.price-compare')?.textContent || '';
        const comparePrice = compareText
          ? Number(compareText.replace(/[^\d,]/g, '').replace(',', '.'))
          : price;

        this.selectedItems.push({
          id: card.dataset.productId,
          name: productName,
          image: productImage,
          price: price,
          comparePrice: comparePrice,
          quantity: 1
        });

        if (display) display.textContent = 1;

      } else {
        // JÁ EXISTE → soma +1
        existing.quantity++;

        if (display) {
          display.textContent = existing.quantity;
        }
      }

      this.renderSummaryItems();

      this.openSummary();
    });

    // CONTROLE DE QUANTIDADE (+ / -)
    const cards = this.querySelectorAll('.digi-club-product-card');

    cards.forEach(card => {
      const plusBtn = card.querySelector('.plus');
      const minusBtn = card.querySelector('.minus');
      const display = card.querySelector('.digi-club-qty-display');

      plusBtn?.addEventListener('click', (e) => {
        e.stopPropagation();

        const item = this.selectedItems.find(
          i => i.id === card.dataset.productId
        );
        if (!item) return;

        item.quantity++;
        display.textContent = item.quantity;

        this.updateItemQuantity(item.id, item.quantity);
      });

      minusBtn?.addEventListener('click', (e) => {
        e.stopPropagation();

        const item = this.selectedItems.find(
          i => i.id === card.dataset.productId
        );
        if (!item) return;

        if (item.quantity > 1) {
          // comportamento normal
          item.quantity--;
          display.textContent = item.quantity;

          this.updateItemQuantity(item.id, item.quantity);

        } else {
          // 👇 QUANDO CHEGAR EM 1 → REMOVE TUDO
          this.selectedItems = this.selectedItems.filter(
            i => i.id !== card.dataset.productId
          );

          // reset visual do card
          card.classList.remove('selected');

          const qtySelector = card.querySelector('.digi-club-quantity-selector');
          qtySelector?.classList.add('is-hidden');

          display.textContent = 1;

          this.renderSummaryItems();

          // opcional: fechar summary se não tiver mais itens
          if (this.selectedItems.length === 0) {
            this.summaryPanel.classList.remove('open');
          }
        }
      });
    });
  }

  selectPlan(planName) {
    this.planOptions.forEach(option => {
      if (option.dataset.plan === planName) {
        option.classList.add('selected');
        this.currentPlan = planName;
        this.nextStepBtn.disabled = false;
      }
    });

    this.updateCategoryBadges(); 
  }

  getPlanDiscount() {
    if (!this.planConfig || !this.currentPlan) return '';

    const config = this.planConfig.split(',');

    for (let item of config) {
      const [plan, discount] = item.split(':');

      if (plan.trim() === this.currentPlan) {
        return `${discount.trim()}% OFF`;
      }
    }

    return '';
  }

  getNumericPlanDiscount() {
    if (!this.planConfig || !this.currentPlan) return 0;

    const config = this.planConfig.split(',');

    for (let item of config) {
      const [plan, discount] = item.split(':');

      if (plan.trim() === this.currentPlan) {
        return Number(discount.trim()) || 0;
      }
    }

    return 0;
  }

  updateCategoryBadges() {
    const badges = this.querySelectorAll('[data-category-badge]');
    const discount = this.getPlanDiscount();

    badges.forEach(badge => {
      badge.textContent = discount;
    });
  }

  setupSummaryToggle() {
    const panel = this.querySelector('[data-summary]');
    const toggleArea = this.querySelector('[data-summary-toggle]');
    const icon = this.querySelector('[data-summary-icon]');
    const products = this.querySelector('.digi-club-products');

    if (!panel || !toggleArea) return;

    toggleArea.addEventListener('click', () => {
    if (
      panel.classList.contains("open")
    ) {

      this.closeSummary();

    } else {

      this.openSummary();

    }
    });
  }

  getVariantKeyword() {
    switch (this.currentPlan) {
      case 'Mensal':
        return 'Frequência: Mensal';
      case 'Bimestral':
        return 'Frequência: 2 meses';
      case 'Trimestral':
        return 'Frequência: 3 meses';
      default:
        return null;
    }
  }

  goToStep(step) {
    this.currentStep = step;

    const title = this.querySelector('.digi-club-modal-title');

    if (title) {
      if (step === 3) {
        title.textContent = 'ÚLTIMO PASSO!';
      } else {
        title.textContent = 'MONTE SUA ASSINATURA';
      }
    }

    this.querySelectorAll('.digi-club-step').forEach(el => {
      el.style.display = 'none';
    });

    const target = this.querySelector(`[data-step="${step}"]`);
    if (target) {
      target.style.display = 'block';
    } 

    // 👇 DECLARA PRIMEIRO
    const container = this.querySelector('.digi-club-modal-container');

    // SUMMARY
    if (step === 2) {
      this.summaryPanel?.classList.remove('is-hidden');
    } else {
      this.summaryPanel?.classList.add('is-hidden');
      this.summaryPanel?.classList.remove('open');
    }

    // FULLSCREEN STEPS
    if (step === 2) {

      this.classList.add(
        "digi-step-2-open"
      );

      this.classList.remove(
        "digi-step-3-open"
      );

      container?.classList.add(
        "digi-step-2-active"
      );

this.renderSummaryItems();

if (this.hasPreset) {

  requestAnimationFrame(() => {

    this.openSummary();

  });

}

this.summaryPanel.classList.remove(
  "is-hidden"
);

if (this.openSummaryOnStepTwo) {

  this.openSummary();

  /*
   * Apenas na primeira entrada.
   */
  this.openSummaryOnStepTwo = false;

} else {

  this.closeSummary();

}

    } else if (step === 3) {
      this.classList.remove('digi-step-2-open');
      this.classList.add('digi-step-3-open');

      const products = this.querySelector('.digi-club-products');
      if (products) {
        products.style.paddingBottom = '0px'; // 👈 ESSENCIAL
      }
    } else {
      this.classList.remove('digi-step-2-open');
      this.classList.remove('digi-step-3-open');
      container?.classList.remove('digi-step-2-active');
    }
  }

  reset() {
    // reset estado interno
    this.selectedItems = [];
    this.currentPlan = '';
    this.currentStep = 1;

    this.openSummaryOnStepTwo = false;

    // STEP 1 — limpar seleção de plano
    this.planOptions.forEach(option => {
      option.classList.remove('selected');
    });

    if (this.nextStepBtn) {
      this.nextStepBtn.disabled = true;
    }

    // progress bar
    if (this.progressFill) {
      this.progressFill.style.width = '0%';
    }

    const toggle = this.querySelector('.digi-club-summary-toggle');
    if (toggle) toggle.textContent = '+';

    // voltar pro step 1
    this.goToStep(1);

    this.closeSummary();

    this.summaryPanel?.classList.add(
      "is-hidden"
    );

    // 👇 RESET VISUAL DOS CARDS
    const cards = this.querySelectorAll('.digi-club-product-card');

    cards.forEach(card => {
      card.classList.remove('selected');

      const qtySelector = card.querySelector('.digi-club-quantity-selector');
      const display = card.querySelector('.digi-club-qty-display');

      qtySelector?.classList.add('is-hidden');

      if (display) {
        display.textContent = 1;
      }
    });

    // 👇 RESET DO PADDING DINÂMICO (ESSENCIAL)
    const products = this.querySelector('.digi-club-products');
    if (products) {
      products.style.paddingBottom = '0px';
    }

    const termsCheckbox = this.querySelector('[data-terms-checkbox]');
    const finalizeBtn = this.querySelector('[data-finalize-btn]');

    if (termsCheckbox) {
      termsCheckbox.checked = false;
    }

    if (finalizeBtn) {
      finalizeBtn.disabled = true;
      finalizeBtn.classList.remove('loading');

      const text = finalizeBtn.querySelector('span');

      if (text) {
        text.textContent = 'FINALIZAR ASSINATURA';
      }
    }
  }

  open() {
    this.reset(); // já tem, mantém

    // 👇 GARANTE QUE NUNCA ABRE SUJO
    const products = this.querySelector('.digi-club-products');
    if (products) {
      products.style.paddingBottom = '0px';
    }

    this.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('active');
    document.body.style.overflow = '';

    // 👇 GARANTE LIMPEZA IMEDIATA
    const products = this.querySelector('.digi-club-products');
    if (products) {
      products.style.paddingBottom = '0px';
    }

    this.alertModal?.classList.remove('active');
    this.reset();
  }

  setupSummaryCloseOutside() {
    const panel = this.querySelector('[data-summary]');
    if (!panel) return;

    document.addEventListener('click', (e) => {
      if (!panel.classList.contains('open')) return;

      const clickedInsideSummary = panel.contains(e.target);
      const clickedProduct = e.target.closest('.digi-club-product-card');

      // 👇 IGNORA clique nos produtos
      if (clickedInsideSummary || clickedProduct) return;

      this.closeSummary();
    });
  }

  updateCheckoutState() {
    const btn = this.querySelector('[data-checkout-btn]');
    if (!btn) return;

    btn.disabled = this.selectedItems.length === 0;
  }

  updateProductsPadding() {
    const panel = this.querySelector('[data-summary]');
    const products = this.querySelector('.digi-club-products');

    if (!panel || !products) return;

    // 👇 NOVO: só aplica no step 2
    if (this.currentStep !== 2) {
      products.style.paddingBottom = '0px';
      return;
    }

    const height = panel.offsetHeight;
    products.style.paddingBottom = height + 'px';
  }

openSummary() {

  if (!this.summaryPanel) {
    return;
  }

  this.summaryPanel.classList.remove(
    "is-hidden"
  );

  this.summaryPanel.classList.add(
    "open"
  );

  const icon =
    this.querySelector(
      "[data-summary-icon]"
    );

  if (icon) {
    icon.textContent = "–";
  }

  this.updateProductsPadding();

}

closeSummary() {

  if (!this.summaryPanel) {
    return;
  }

this.summaryPanel.classList.remove(
  "open"
);

  const icon =
    this.querySelector(
      "[data-summary-icon]"
    );

  if (icon) {
    icon.textContent = "+";
  }

  this.updateProductsPadding();

}

  checkout() {
    if (this.selectedItems.length === 0) return;

    this.goToStep(3);
    this.renderTimeline();
  }

  renderTimeline() {
    const container = this.querySelector('[data-timeline]');
    if (!container) return;

    container.innerHTML = '';

    const frequencyDays = this.getFrequencyDays();
    const labels = ['Primeira vez', 'Segunda vez', 'Terceira vez'];

    const monthNames = [
      'janeiro','fevereiro','março','abril','maio','junho',
      'julho','agosto','setembro','outubro','novembro','dezembro'
    ];

    // 👉 HOJE + 1 (mesma regra da section)
    let firstShipDate = new Date();
    firstShipDate.setDate(firstShipDate.getDate() + 2);

    for (let i = 0; i < 3; i++) {
      let shipDate = new Date(firstShipDate);

      if (frequencyDays % 30 === 0) {
        const monthsToAdd = (frequencyDays / 30) * i;

        const targetDay = shipDate.getDate();

        shipDate.setMonth(shipDate.getMonth() + monthsToAdd);

        // 🔥 corrige overflow (fev / meses curtos)
        if (shipDate.getDate() < targetDay) {
          shipDate.setDate(0);
        }

      } else {
        shipDate.setDate(
          shipDate.getDate() + (frequencyDays * i)
        );
      }

      const day = shipDate.getDate();
      const month = monthNames[shipDate.getMonth()];

      const item = document.createElement('div');
      item.className = 'digi-timeline-item';

      item.innerHTML = `
        <div class="digi-timeline-dot"></div>
        <div class="digi-timeline-label">${labels[i]}</div>
        <div class="digi-timeline-label-date">${day} de ${month}</div>
      `;

      container.appendChild(item);
    }
  }

  getFrequencyDays() {
    switch (this.currentPlan) {
      case 'Mensal':
        return 30;
      case 'Bimestral':
        return 60;
      case 'Trimestral':
        return 90;
      default:
        return 30;
    }
  }

  setupTerms() {
    const checkbox = this.querySelector('[data-terms-checkbox]');
    const btn = this.querySelector('[data-finalize-btn]');

    if (!checkbox || !btn) return;

    checkbox.addEventListener('change', () => {
      btn.disabled = !checkbox.checked;
    });

    btn.addEventListener('click', () => {

      // 👇 troca o texto
      const text = btn.querySelector('span');
      if (text) {
        text.textContent = 'FINALIZANDO';
      }

      // 👇 ativa loading
      btn.classList.add('loading');
      btn.disabled = true;

      setTimeout(() => {
        this.finalizeSubscription();
      }, 100);
    });
  }

  formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  }

renderSummaryItems() {
  const itemsList = this.querySelector('[data-items-list]');
  if (!itemsList) return;

  itemsList.innerHTML = '';

  if (this.selectedItems.length === 0) {
    itemsList.classList.add('is-empty');
  } else {
    itemsList.classList.remove('is-empty');
  }

  const items = this.selectedItems;

  // 👇 define modo
  const isStack = items.length > 4;

  if (isStack) {
    itemsList.classList.add('is-stack');
  } else {
    itemsList.classList.remove('is-stack');
  }

  // 👇 quantos mostrar
  const visibleItems = isStack ? items.slice(0, 4) : items;

  visibleItems.forEach(item => {
    const el = document.createElement('div');
    el.className = 'digi-thumb';

    el.innerHTML = `
      <img src="${item.image}" alt="${item.name}">
      <div class="digi-thumb-qty">${item.quantity}</div>
    `;

    itemsList.appendChild(el);
  });

  // 👇 se tiver mais, adiciona +X
  if (isStack) {
    const remaining = items.length - 4;

    const more = document.createElement('div');
    more.className = 'digi-thumb digi-thumb-more';
    more.textContent = `+${remaining}`;

    // 👇 CLICK
    more.addEventListener('click', (e) => {
      e.stopPropagation(); // 👈 ESSENCIAL

      itemsList.classList.remove('is-stack');
      this.renderAllItemsExpanded();
    });

    itemsList.appendChild(more);
  }

  this.updateSummaryPricing();
  this.updateProductsPadding();
  this.updateCheckoutState();
  this.updateGiftState();
}

  updateSummaryPricing() {
    const subtotalEl = this.querySelector('[data-subtotal]');
    const totalEl = this.querySelector('[data-total]');
    const savingEl = this.querySelector('.digi-club-saving');
    const fromEl = this.querySelector('.price-from');
    const toEl = this.querySelector('.price-to');

    const subtotal = this.selectedItems.reduce((acc, item) => {
      return acc + (item.comparePrice * item.quantity);
    }, 0);

    const total = this.selectedItems.reduce((acc, item) => {
      return acc + (item.price * item.quantity);
    }, 0);

    const discountValue = subtotal - total;

    if (subtotalEl) subtotalEl.textContent = this.formatMoney(subtotal);
    if (totalEl) totalEl.textContent = this.formatMoney(total);
    if (fromEl) fromEl.textContent = this.formatMoney(subtotal);
    if (toEl) toEl.textContent = this.formatMoney(total);
    savingEl.textContent = this.formatMoney(discountValue);
  }

  finalizeSubscription() {
    if (this.selectedItems.length === 0) return;

    const finalizeBtn = this.querySelector('[data-finalize-btn]');

    try {
      const cartLines = [];

      // 1. Adiciona os produtos com a variante de frequência escolhida
      this.selectedItems.forEach(item => {
        const card = this.querySelector(
          `.digi-club-product-card[data-product-id="${item.id}"]`
        );

        if (!card) return;

        const variants = JSON.parse(
          card.dataset.variants || '[]'
        );

        const keyword = this.getVariantKeyword();

        const variant = variants.find(v =>
          v.title.includes(keyword)
        );

        if (!variant) return;

        cartLines.push(
          `${variant.id}:${item.quantity}`
        );
      });

      if (cartLines.length === 0) {
        throw new Error(
          'Nenhuma variante compatível com a assinatura foi encontrada.'
        );
      }

      // 2. Adiciona o brinde no mesmo carrinho
      const giftBlock = this.querySelector(
        '[data-gift-variant-id]'
      );

      if (giftBlock) {
        const giftVariantId = Number(
          giftBlock.dataset.giftVariantId
        );

        if (giftVariantId) {
          cartLines.push(
            `${giftVariantId}:1`
          );
        }
      }

      // 3. Adiciona o flyer no mesmo carrinho
      if (this.enableSubscriptionFlyer) {
        cartLines.push(
          '46723869212862:1'
        );
      }

      // Exemplo:
      // /cart/44990784241854:1,ID_BRINDE:1,46723869212862:1
      const checkoutUrl =
        `/cart/${cartLines.join(',')}`;

      console.log(
        '[Modal] Abrindo checkout:',
        checkoutUrl
      );

      /*
       * O cart permalink cria o carrinho completo diretamente
       * na Shopify e abre o checkout, sem fetch ou XMLHttpRequest.
       */
      window.location.assign(checkoutUrl);

    } catch (error) {
      console.error(
        '[Modal] Erro ao montar a assinatura:',
        error
      );

      if (finalizeBtn) {
        finalizeBtn.disabled = false;
        finalizeBtn.classList.remove('loading');

        const buttonText = finalizeBtn.querySelector('span');

        if (buttonText) {
          buttonText.textContent = 'TENTAR NOVAMENTE';
        }
      }
    }
  }

  updateItemQuantity(productId, quantity) {
    const item = this.selectedItems.find(i => i.id === productId);

    if (item) {
      item.quantity = quantity;
    }

    this.renderSummaryItems();
  }

  renderAllItemsExpanded() {
    const itemsList = this.querySelector('[data-items-list]');
    if (!itemsList) return;

    itemsList.innerHTML = '';

    this.selectedItems.forEach(item => {
      const el = document.createElement('div');
      el.className = 'digi-thumb';

      el.innerHTML = `
        <img src="${item.image}" alt="${item.name}">
        <div class="digi-thumb-qty">${item.quantity}</div>
      `;

      itemsList.appendChild(el);
    });
  }
    
  updateGiftState() {
    const giftBlock = this.querySelector('.digi-club-gift-block');
    const status = this.querySelector('.digi-gift-status');

    if (!giftBlock || !status) return;

    if (this.selectedItems.length > 0) {
      giftBlock.classList.add('active');
      status.textContent = 'LIBERADO!';
    } else {
      giftBlock.classList.remove('active');
      status.textContent = 'BRINDE BLOQUEADO';
    }
  }

  openAlertModal({
    title,
    description,
    buttonText = 'FINALIZAR ASSINATURA'
  }) {
    const titleEl = this.querySelector('[data-alert-title]');
    const descEl = this.querySelector('[data-alert-description]');
    const btnEl = this.querySelector('[data-alert-btn]');

    if (titleEl) {
      titleEl.textContent = title;
    }

    if (descEl) {
      descEl.textContent = description;
    }

    if (btnEl) {
      btnEl.textContent = buttonText;
    }

    this.open();

    this.alertModal?.classList.add('active');

    btnEl.onclick = () => {
      window.location.href = '/checkout';
    };
  }
}

customElements.define('digi-club-modal', DigiClubModal);